// extracted by mini-css-extract-plugin
export var container = "PageContainer_container__WmMRE";
export var lg = "992px";
export var md = "768px";
export var shared = "\"../../shared.module.css\"";
export var xl = "1200px";